import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import ManageMembersGroup, { type Action } from 'modules/posts/components/Groups/ManageMembers'

const ManageMembersGroupPage = ({ action }: { action: Action }) => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const location = useLocation()

  const getBackPath = () => {
    if (location.pathname.includes(navigation.dashboard.fullPath())) {
      return navigation.dashboard.fullPath()
    }
    return navigation.communities.id.fullPath({ id: id || '' })
  }

  return (
    <ManageMembersGroup
      action={action}
      onClose={() => navigate(getBackPath())}
      groupId={id ?? ''}
    />
  )
}

export default ManageMembersGroupPage
